import type { ReactNode } from 'react';
import { RequiredIndicator } from './RequiredIndicator';
import { UnitTitleIcon } from './UnitTitle';

/** A unit's title over its fields while a whole form is filled in (create mode). */
export function UnitHeading({
  title,
  required,
  icon = null
}: {
  title: string;
  required: boolean;
  /** See `UnitEditorProps.icon`. */
  icon?: ReactNode;
}) {
  const text = (
    <>
      {title}
      {required && <RequiredIndicator />}
    </>
  );
  if (icon === null) {
    return <h3 className="font-bold text-fg-muted">{text}</h3>;
  }
  return (
    <h3 className="flex items-center gap-x-2 font-bold text-fg-muted">
      <UnitTitleIcon>{icon}</UnitTitleIcon>
      <span>{text}</span>
    </h3>
  );
}
